import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654b1e07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "area" }
const _hoisted_2 = { class: "step1" }
const _hoisted_3 = { key: 2 }

import { withDefaults, ref } from 'vue';
import StepActiveIcon from './icons/StepActiveIcon.vue';
import { IStep } from '@/types'
import CompletedStepIcon from './icons/CompletedStepIcon.vue';

interface IProps {
  steps: IStep[];
  currentStep: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomProgressForm',
  props: {
    steps: {},
    currentStep: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "9fa08d2e": (steps.value)
}))

const props = __props;
const steps = ref(props.steps.length)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.steps, (step, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: String(step.label),
        class: "d-flex flex-column align-center relative"
      }, [
        _createElementVNode("p", {
          style: _normalizeStyle({ color: _ctx.currentStep === step.label ? '#212529' : '' }),
          class: "title-step"
        }, _toDisplayString(step.label), 5),
        _createElementVNode("div", _hoisted_2, [
          (step.completed)
            ? (_openBlock(), _createBlock(CompletedStepIcon, { key: 0 }))
            : (_ctx.currentStep === step.label)
              ? (_openBlock(), _createBlock(StepActiveIcon, { key: 1 }))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(index + 1), 1))
        ]),
        _createElementVNode("div", {
          style: _normalizeStyle({ background: _ctx.currentStep === step.label || step.completed ? '#FFDECC' : '' }),
          class: "line-step-l"
        }, null, 4),
        _createElementVNode("div", {
          style: _normalizeStyle({ background: step.completed ? '#FFDECC' : '' }),
          class: "line-step-r"
        }, null, 4)
      ]))
    }), 128))
  ]))
}
}

})